<template>
    <div>
        <b-button @click="openModal()">Upload Log Notes</b-button>
        <validation-observer v-slot="vo" slim>
            <b-modal size="xl"
                     centered
                     no-close-on-backdrop
                     no-close-on-esc
                     v-model="modalOpen"
                     @shown="resetModal"
                     v-on:ok.prevent="vo.handleSubmit(handleLogNotesSubmit)"
                     v-on:cancel="resetModal()">
                <template #modal-header>
                    <h5 class="modal-title">Upload Log Notes</h5>
                </template>

                <template #default>

                    <div v-if="!processed">
                        <b-alert v-model="showErrors" variant="danger" dismissible>
                            <div v-for="(error, index) in errors" :key="index">
                                <p>{{ error }}</p>
                            </div>
                        </b-alert>

                        <b-form-row>
                            <b-form-group label="LogFiles"
                                          label-for="logFiles"
                                          class="col-12">
                                <attachments v-model="attachments"
                                             :all-attachment-classifications="[ { text: 'Log Notes', value: 'logNotes' } ]"
                                             attachment-classification-selection="hidden"
                                             attachment-description-input="optional"
                                             :can-add-attachments="true"
                                             v-on:uploadInProgress="updateDisableCreate">
                                </attachments>

                            </b-form-group>
                        </b-form-row>

                    </div>

                    <div v-else>
                        <b-alert v-model="showErrors" variant="danger" dismissible>
                            <div v-for="(error, index) in errors" :key="index">
                                <p>{{ error }}</p>
                            </div>
                        </b-alert>
                        <ejs-grid id="logNotesGrid"
                                  ref="logNotesGrid"
                                  :dataSource="gridData"
                                  :allowSorting="false"
                                  :allowResizing="false"
                                  :allowPaging="false"
                                  :enableStickyHeader="true"
                                  :queryCellInfo="customiseCell"
                                  :allowGrouping="true"
                                  :groupSettings="groupSettings"
                                  :selectionSettings="selectionSettings"
                                  :dataBound="dataBound">
                            <e-columns>
                                <!-- :enablePersistence="true" -->

                                <e-column field="workItemId" :headerText="'Work Item'" :template="'logNotesColumnTemplate'" width="100"></e-column>

                                <e-column type='checkbox' width='25'></e-column>
                                <e-column field="startTime" :headerText="'Start Time'"></e-column>
                                <e-column field="endTime" :headerText="'End Time'"></e-column>
                                <e-column field="adjournmentDisplayName" :headerText="'Adjournment Type'"></e-column>
                            </e-columns>
                            <template v-slot:logNotesColumnTemplate="{data}">
                                {{data.epiqNumber}} : {{data.matterDescription}} | {{data.courtInterviewOrganisation}} @ {{data.proposedStartTime}}
                            </template>
                        </ejs-grid>
                    </div>
                </template>


                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-secondary" @click="cancel()" :disabled="busy">Cancel</button>

                    <button v-if="!processed" type="button" class="btn btn-primary" @click="ok()" :disabled="busy || disabled">
                        <b-spinner small v-if="busy" label="Processing Log Notes..."></b-spinner>
                        <template v-if="!busy">
                            Process
                        </template>
                    </button>

                    <button v-else type="button" class="btn btn-primary" @click="ok()" :disabled="busy || disabled">
                        <b-spinner small v-if="busy" label="Creating Entries..."></b-spinner>
                        <template v-if="!busy">
                            Create
                        </template>
                    </button>
                </template>
            </b-modal>

        </validation-observer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import { GridPlugin, Group } from '@syncfusion/ej2-vue-grids';

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import DateTimeMixin from '../mixins/DateTimeMixin';
    import GridMixins from '../mixins/GridMixins';

    Vue.use(BootstrapVue);
    Vue.use(GridPlugin);

    var logNotesModal_vueComponent = null;
    function logNotesGrid_getGroupCaption(field, headerText, value) {
        return logNotesModal_vueComponent.getGroupCaption(field, headerText, value);
    }
    window.logNotesGrid_getGroupCaption = logNotesGrid_getGroupCaption;

    export default {
        name: 'logNotesModal',
        mixins: [ErrorsMixin, DateTimeMixin, GridMixins],
        provide: {
            grid: [Group]
        },
        data: function () {
            return {
                groupSettings: { showDropArea: false, columns: ['workItemId'], showGroupedColumn: false, disablePageWiseAggregates: true, captionTemplate: "${logNotesGrid_getGroupCaption(data)}" },
                selectionSettings: { checkboxOnly: true },
                modalOpen: false,
                showErrors: false,
                errors: [],
                busy: false,
                disabled: false,
                processed: false,
                attachments: [],
                gridData: [],
                logNotesGrid: null,
                subGrid: null,
                columnFormats: {
                    'proposedStartTime': {
                        type: 'datetime',
                        options: { outputAsUTC: true }
                    },
                    'startTime': {
                        type: 'datetime',
                        options: { outputAsUTC: true }
                    },
                    'endTime': {
                        type: 'datetime',
                        options: { outputAsUTC: true }
                    },
                },
                args: null,
            };
        },
        methods: {
            dataBound: function () {
                this.$refs.logNotesGrid.ej2Instances.groupModule.collapseAll();
            },
            resetModal: function () {
                this.showErrors = false;
                this.errors = [];
                this.busy = false;
                this.disabled = false;
                this.attachments = [];
                this.processed = false;
                this.gridData = [];
            },
            openModal: function () {
                this.modalOpen = true;
            },
            handleLogNotesSubmit: function () {
                if (!this.processed) {
                    this.processEntries();
                } else {
                    this.submitEntries();
                }
            },
            subdata: function (args, another) {
                this.args = args + another;

            },
            updateDisableCreate: function (uploadInProgress) {
                this.disabled = uploadInProgress;
            },
            customiseCell: function (args) {
                this.defaultEJ2DataGridQueryCellInfo(args, this.columnFormats);
            },
            getGroupCaption: function (data) {
                if (data.field == "workItemId") {
                    var datetime = this.formatDateTime(this.parseDateTime(data.items[0].proposedStartTime, null, false), "DD/MM/yy HH:mmA");
                    return data.items[0].epiqNumber + ": " + data.items[0].matterDescription + " | " + data.items[0].courtInterviewOrganisation + " @" + datetime;
                }
                return data.headerText + ": " + data.key;
            },
            processEntries: function () {

                this.busy = true;
                var url = this.$urlHelper.getApiUrl('LogNotes', 'process');

                var data = { attachments: [], };
                this.attachments.forEach(attachment => {
                    data.attachments.push({ fileId: attachment.fileId, description: attachment.descriptionString });
                })

                axios
                    .post(url, JSON.stringify(data), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then((response) => {
                        this.resetModal();
                        this.processed = true;
                        this.gridData = response.data.result;

                        this.$bvToast.toast('Log note files processed successfully', {
                            title: 'Log Notes Processed',
                            variant: 'success',
                            appendToast: true
                        });
                        setTimeout(() => {
                            this.gridSetup();
                        }, 250);
                    })
                    .catch(ex => {
                        this.errors = this.handleAxiosException(ex);
                        this.showErrors = true;
                        this.busy = false;
                    });
            },
            submitEntries: function () {
                this.busy = true;
                var url = this.$urlHelper.getApiUrl('LogNotes', 'create');

                var selectedRecords = this.logNotesGrid.getSelectedRecords();

                axios
                    .post(url, JSON.stringify(selectedRecords), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.resetModal();
                        this.modalOpen = false;

                        this.$bvToast.toast('Recorded segments created successfully', {
                            title: 'Recorded Segments Created',
                            variant: 'success',
                            appendToast: true
                        });
                        setTimeout(() => {
                            this.gridSetup();
                        }, 250);
                    })
                    .catch(ex => {
                        this.errors = this.handleAxiosException(ex);
                        this.showErrors = true;
                        this.busy = false;
                    });
            },
            gridSetup: function () {
                this.logNotesGrid = this.$refs.logNotesGrid.ej2Instances;
                this.defaultEJ2DataGridCreatedHandler(this.logNotesGrid);
            }

        },
        mounted: function () {
            logNotesModal_vueComponent = this;
        }

    }
</script>

